export async function factoryApi() {
  return useGet('/factory/');
}
export async function projectTypeApi() {
  return useGet('/projectType/children');
}
export async function addApi(params) {
  return usePost('/shipment/save', params);
}
export async function getListApi(data) {
  return usePost('/shipment/lists', data);
}
export async function getShipmentInfoApi(id) {
  return useGet(`/shipment/findById/${id}`);
}
export async function changeStatusApi(id) {
  return usePut(`/shipment/changeStatus/${id}`);
}